import { render, staticRenderFns } from "./notice_1.vue?vue&type=template&id=3f108a6b&scoped=true"
var script = {}
import style0 from "./notice_1.vue?vue&type=style&index=0&id=3f108a6b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f108a6b",
  null
  
)

export default component.exports